import { Box } from "@chakra-ui/layout";
import { PageSectionHeading } from "components/molecules/PageSection";

export const ProductPageSection = ({
  id,
  title,
  children,
  subheading,
}: {
  id: string;
  title: string;
  children: React.ReactNode;
  subheading?: string;
}) => {
  return (
    <Box display={{ lg: "flex" }} id={id}>
      <Box w={300} mr={12}>
        <PageSectionHeading mb={{ base: 5, lg: 3 }}>{title}</PageSectionHeading>
        {subheading && (
          <Box fontSize="md" color="gray.600">
            {subheading}
          </Box>
        )}
      </Box>
      <Box flex={1} mt={{ base: 12, lg: 0 }}>
        {children}
      </Box>
    </Box>
  );
};
